<script>
export default {
  name: "PrintCombineInvoice",

  data() {
    return {
        main: this.$route.query.organisationId,
    patient: {},
      invoiceinfo:{}, 
      organizations: [],
      insuranceDetails:{},
      otherInsuranceDetails:{}, 
      invoiceLines: {
        combinedPaymentnInvoiceItemsDetails: [],
        combinedPaymentnInvoiceDetails: [],
        visitNo:'',
      },
      footerMessage: {},
      visitDetail:[],
    age:0,
nationalId:0,  dateofAdmission:'',
dateofDischarge:'',
ward:'',
bed:'', 
    };
  },

  computed: {
    totalAmount() {
      if (!this.invoiceLines.combinedPaymentnInvoiceDetails.length) return 0;
      this.getPatientVisitDetails(this.invoiceLines.visitNo);
      return this.invoiceLines.combinedPaymentnInvoiceDetails
        .map((line) => parseFloat(line.amount))
        .reduce((sum, amount) => sum + amount);
    },
    principalDetails() {
            if(!this.main) return 0;

            const orgs = this.organizations.filter(org => org.organizationID == this.main);

            return orgs.length ? orgs[0] : {};
        },
        invoicenumber() {
          if(this.main==0) return  this.invoiceinfo.receiptnInvoiceNo ;
if(!this.invoiceLines.combinedPaymentnInvoiceDetails.length) return this.invoiceinfo.receiptnInvoiceNo;

return (this.invoiceLines.combinedPaymentnInvoiceDetails.filter(g=>g.organizationID==this.main).map(line => line.detailReceiptnInvoiceNo)[0]);

},
        invoicedate() {
            if(this.invoiceLines.combinedPaymentnInvoiceDetails.length==0){
             return this.invoiceinfo.txnDate;   
            }
            else if(this.main==0){
                return this.invoiceinfo.txnDate; 
            }else{
                const invoicelineitem = this.invoiceLines.combinedPaymentnInvoiceDetails.filter(lineitem => lineitem.organizationID == this.main);
return invoicelineitem[0].txnDate;
            }
          
        },
  },

  mounted() {
    this.$root.loading = true;
    Promise.all([ this.fetchPatient(), this.fetchCombinedPayments(),this.fetchOrganizations(),this.fetchMessage(), ])
      .then(() => {
        this.$root.loading = false;
        setTimeout(() => {
          window.print();
        }, 250);
      })
      .catch(() => {
        this.$root.loading = false;
      });
  },

  methods: {
    fetchInsuranceDetails() {
             this.$root.loading = true;
            let url = `MasterData/GetSpecificOrganization`;
                url += `?OrganizationId=${this.$route.query.organisationId}`;

            return this.$http.get(url).then(({data}) => {
                    this.insuranceDetails = data.length ? data[0] : {};
                    this.$root.loading = false;
                }).catch(() => { this.$root.loading = false; });
        },
    fetchOrganizations() {
            let url = `PatientRegistration/GetPatientInsurances`;
                url += `?CustomerID=${this.$route.query.patientID}`;

            return this.$http.get(url).then(({data}) => {
                    this.organizations = data;
                }).catch(() => {});
        },
    fetchPatient() {
      let url = `PatientRegistration/GetSpecificPatient`;
      url += `?PatientID=${this.$route.query.patientID}`;

      return this.$http
        .get(url)
        .then((response) => {
          this.patient = response.data.length ? response.data[0] : {};

          return Promise.resolve();
        })
        .catch(() => { return Promise.reject(); });
    },

    fetchCombinedPayments() {
      const url = `Accounts/GetCombinedPaymentsnInvoicesDetails`;

      return this.$http
        .get(`${url}?ReceiptnInvoiceNo=${this.$route.query.invoiceNo}`)
        .then((response) => {
          this.invoiceLines = response.data;
          if(this.invoiceLines.combinedPaymentnInvoices.length>0)
          {
            this.invoiceinfo=this.invoiceLines.combinedPaymentnInvoices[0];
          }
          else
          {
            this.invoiceinfo={};
          }

          return Promise.resolve();
        })
        .catch(() => { return Promise.reject(); });
    },
    getPatientVisitDetails(visitNo) {
      let url = `Visits/GetSpecificPatientVisit`;

      return this.$http
        .get(`${url}?VisitId=${visitNo}`)
        .then((response) => {
          this.visitDetail = response.data;
          this.age= this.visitDetail.specificVisitRecord.age;
       this.nationalId= this.visitDetail.specificVisitRecord.nationalid;
     //  this.dateofAdmission= this.visitDetail.specificVisitRecord.admissionDate;
//this.dateofDischarge= this.visitDetail.specificVisitRecord.disschargeDate;

this.dateofAdmission= this.invoiceinfo.invoicingAdmissionDate||this.visitDetail.specificVisitRecord.admissionDate;
this.dateofDischarge= this.invoiceinfo.invoicingDischargeDate||this.visitDetail.specificVisitRecord.disschargeDate;
this.ward= this.visitDetail.specificVisitRecord.ward;
this.bed= this.visitDetail.specificVisitRecord.bed;
        })
        .catch(() => {this.visitDetail=[]});
    },
    fetchMessage() {
            let url = `MasterData/GetSpecificOrganizationMessageforGroup`;
                url += `?Group=Proforma`;
            return this.$http.get(url).then(({data}) => {
                this.footerMessage = data.length ? data[0] : {};
            })
        },
  },
};
</script>
<template>
  <div class="w-full flex flex-wrap">
    <tail-address-header></tail-address-header>
    <div class="w-full p-1 text-center my-3">
      <h5 class="font-medium text-base uppercase">INVOICE FOR TREATMENT</h5> 
    </div>
  <tail-stamp></tail-stamp>
  <div class="w-full flex flex-row p-2 bg-gray-300 mt-2">
                <div class="flex-1 p-tiny">
                    <h5 class="font-bold text-sm uppercase"  v-if="$root.checkAuth('ViewDateOnInvoicePrintOut')">Date:{{invoicedate?invoicedate:invoiceinfo.txnDate | dateFormat}}</h5> 
                    
                </div>
                <div class="flex-1 p-tiny">
                   <h5 class="font-bold text-sm uppercase"> Invoice No: {{invoicenumber}}</h5> 
                </div>
            </div>
            <div class="flex-1">
                    <div class="w-full flex flex-col content-start">
                       
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Invoice To</h5>
                        </div>
                        <div class="w-1/2 p-tiny">
                            <label for="grid-insurance" class="label-control">Main Insurance</label>
                            <select v-model.number="main" id="grid-insurance" class="input-control input-sm text-xs">
                                <option value="0">select main insurance</option>
                                <option v-for="insurance in invoiceLines.combinedPaymentnInvoiceDetails" 
                                    :key="insurance.organizationID" 
                                    :value="insurance.organizationID">{{insurance.organization}}</option>
                            </select>
                        </div>
                        <!-- <div class="w-1/2 p-tiny">
                             <h5 class="font-bold text-sm uppercase"> Invoice No: {{invoiceinfo.receiptnInvoiceNo}}</h5>
                        </div> -->
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Address: {{insuranceDetails.postalAddress || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Contact: {{insuranceDetails.cellphone || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Scheme: {{otherInsuranceDetails.scheme || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">Package: {{otherInsuranceDetails.package || `-`}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Bill Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">Name: {{patient.names}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">MRN:{{patient.patienT_ID}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">OP: {{patient.opfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">IP: {{patient.ipfileno || `-`}}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">DOB: {{patient.dob | dateFormat}}</h5>
                        </div>
                    </div>
                </div>
                <div class="flex-1">
                    <div class="w-full flex flex-col content-start p-1">
                        <div class="flex-1 p-1">
                            <h5 class="font-bold text-sm uppercase">Principal Details</h5>
                        </div>
                        <div class="flex-1 p-tiny">

                            <h5 class="font-medium text-sm capitalize">
                                Name: {{ principalDetails.patientName }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member No:{{ principalDetails.memberno }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Member ID: {{ principalDetails.memberIDNo || `-` }}</h5>
                        </div>
                        <div class="flex-1 p-tiny">
                            <h5 class="font-medium text-sm">
                                Employer: {{ principalDetails.employer || `-` }}</h5>
                        </div>
                    </div>
                </div> 
         <!--         <div class="flex flex-wrap w-full my-2 border-t-2 border-gray-400 px-1">
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Name: {{ patient.names }}</h5> 
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">MRN: {{ patient.patienT_ID }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">IP NO: {{ patient.ipfileno }}</h5>
      </div>
      <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">OP NO: {{ patient.opfileno }}</h5>
      </div> -->
      <!-- <div class="flex-1 my-1">
        <h5 class="font-semibold text-sm">Visit No: {{ patient.visitNo }}</h5>
      </div> -->
      <!-- <div class="w-full my-1">
        <h5 class="font-medium text-xs">P Mode: {{ patient.pMode }}</h5>
      </div> -->
    <!-- </div>
    <div class="w-full text-center my-1">
      <h5 class="font-bold text-base uppercase">
        Invoice No: {{ $route.query.invoiceNo }}
      </h5>
    </div> -->
    <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Ward: 
               <span class="text-blue-800">{{ ward || `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Bed: 
               <span class="text-blue-800">{{bed|| `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Admitted : 
               <span class="text-blue-800">{{ dateofAdmission|dateFormat }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Date Discharged : 
               <span class="text-blue-800">{{dateofDischarge|dateFormat}}</span></h6>
            </div>
            </div>
     
            <!-- <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
                <h6 class="w-full font-bold text-center">Patient  </h6>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left  pl-2">Name: 
               <span class="text-blue-800">{{ patient.names }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">OP File No: 
               <span class="text-blue-800">{{  patient.ipfileno || `-` }}</span></h6>
            </div>
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">IP File No: 
               <span class="text-blue-800">{{ patient.opfileno || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Age: 
               <span class="text-blue-800">{{ patient.age || `-` }} Yr(s)</span></h6>
            </div>
            
        </div>  -->
        
        <!-- <div class="w-full flex flex-wrap p-1 border-b-dotted border-b-2 border-b-black-600 border-t-dotted border-t-2 border-t-black-600">
           <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">ID No: 
               <span class="text-blue-800">{{ patient.nationalid|| `-` }} </span></h6>
            </div> 
            <div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Member No: 
               <span class="text-blue-800">{{ patient || `-` }}</span></h6>
            </div><div class="flex-1">
                <h6 class="w-full font-bold text-left pl-2">Dependant : 
               <span class="text-blue-800">{{ patient.opfileno || `-` }}</span></h6>
            </div>
            </div> -->
    <table class="table">
      <thead class="text-sm">
        <tr class="w-full flex">
          <th class="p-tiny flex-1" v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">Date</th>
            <th class="p-tiny w-1/2">Item</th>
          <!-- <th class="p-tiny flex-1">Bill No</th> -->
          <th class="p-tiny flex-1">Qty</th>
          <th class="p-tiny flex-1">Amount</th>
          <th class="p-tiny flex-1">Total</th>
        </tr>
      </thead>
      <tbody class="text-xs flex flex-col items-center">
        <tr
          class="w-full flex"
          v-for="(line,
          idxa) in invoiceLines.combinedPaymentnInvoiceItemsDetails"
          :key="idxa"
        >
         <td class="p-tiny flex-1" v-if="$root.checkAuth('ViewItemDateOnInvoicePrintOut')">{{ line.txnDate|dateFormat }}</td>
         <td class="p-tiny w-1/2">{{ line.service }}</td>
          <!-- <td class="p-tiny flex-1">{{ line.billNo }}</td> -->
          <td class="p-tiny flex-1">{{ line.quantity }}</td>
          <td class="p-tiny flex-1">{{ line.charge | numberFormat }}</td>
          <td class="p-tiny flex-1">{{ line.grandTotal | numberFormat }}</td>
        </tr>
        <!-- <tr
          class="w-full flex"
          v-for="(detail) in invoiceLines.combinedPaymentnInvoiceDetails"
          :key="`${detail.combinedDetailID}__`"
        >
        
          <th colspan="5" class="p-tiny flex-1 text-right">
            {{ detail.organization || '-' }}: {{ detail.amount | numberFormat }}
          </th>
        </tr>
        <tr class="w-full flex">
          <th colspan="5" class="p-tiny flex-1 text-right uppercase">
            Total: {{ totalAmount | numberFormat }}
          </th>
        </tr> -->
        <tr class="w-full flex" v-show="main==0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Total Hospital bill: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> <tr class="w-full flex"  v-show="main==0" 
                            v-for="(detail, idx) in invoiceLines.combinedPaymentnInvoiceDetails" 
                            :key="`${idx}__`">
                             
                             <th colspan="5" class="p-tiny flex-1 text-right">
                                {{ detail.organization }} Ref: {{ detail.detailReceiptnInvoiceNo }}: {{ detail.amount | numberFormat }}
                            </th>
                        </tr>
                        <!-- <tr class="w-full flex"  v-show="main==0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Net Due: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> -->
                        <tr class="w-full flex" v-show="main>0">
                            <th colspan="5" class="p-tiny flex-1 text-right uppercase">
                                Total Hospital bill: {{ totalAmount | numberFormat }}
                            </th>
                        </tr> <tr class="w-full flex"  v-show="main>0" 
                            v-for="(xx, idxx) in invoiceLines.combinedPaymentnInvoiceDetails.filter(g=>g.organizationID!== parseFloat(main))" 
                            :key="`${idxx}__`">
                             
                             <th colspan="5" class="p-tiny flex-1 text-right">
                               {{ xx.organization }} Ref: {{ xx.detailReceiptnInvoiceNo }}: {{ xx.amount | numberFormat }}
                            </th>
                        </tr>
                        <tr class="w-full flex"  v-show="main>0" 
                            v-for="(ty, idxxc) in invoiceLines.combinedPaymentnInvoiceDetails.filter(g=>g.organizationID==main)" 
                            :key="`${idxxc}__`">
                             
                             <th colspan="5" class="p-tiny flex-1 text-right"   v-show="main>0" >
                                Net Due:   {{ ty.organization }} Ref: {{ ty.detailReceiptnInvoiceNo }}: {{ ty.amount | numberFormat }}
                            </th>
                        </tr>
      </tbody>

    </table>
    <div class="w-full flex flex-wrap p-1 mt-1">
                    <div class="flex-1">
                        <!-- <h5 class="text-sm font-medium">Patient Signature: .........................</h5> -->
                    </div>
                    <div class="flex-1 text-right">
                        <h5 class="text-sm font-medium">
                            Served By:  {{ invoiceinfo.userName}}</h5>
                    </div>
                </div>
                <div class="w-full p-1 text-center mt-1">
                    <h5 class="font-medium text-sm italic">{{ footerMessage.message }}</h5>
                </div>
                <tail-signature></tail-signature>
   
  </div>
</template>
